// @flow

import type { Action } from './store.type';
import {
  CreateRecommendationWidgetResponseType,
  RecommendationWidgetType,
  WidgetDesignSettingType,
  ListManualRecommendationResponseType,
  ManualRecommendationType,
  ManualRecommendationResponseType,
  AIModelStatusRequestType,
  AIModelStatusResponseType
} from 'src/models/recommendation';

type RecommendationWidgetsSuccess = {
  data: Array<RecommendationWidgetType>,
  total: number,
  totalRules: number,
  waitSyncAt: number,
  scheduleSyncIn: number,
  scheduleSyncAfter: number
};

type RecommendationWidgetSuccess = {
  widgetSettings: RecommendationWidgetType,
  widgetDesignShareableSettings: WidgetDesignSettingType
};

type CreateRecommendationWidgetSuccess = {
  data: CreateRecommendationWidgetResponseType
};

type ActivateAIBaseSuccess = {
  status: string
};

type GetAISyncStatusSuccess = {
  status: string
};

type RecommendationFailure = {
  error: any
};

export type ManualRecommendationParams = {
  q?: string,
  recommendationType?: ManualRecommendationType,
  skip?: number,
  limit?: number
};

/* #region: Get recommendation widgets */
export const GET_RECOMMENDATION_WIDGETS_REQUEST = 'GET_RECOMMENDATION_WIDGETS_REQUEST';
type GET_RECOMMENDATION_WIDGETS_REQUEST_TYPE = 'GET_RECOMMENDATION_WIDGETS_REQUEST';

export const GET_RECOMMENDATION_WIDGETS_SUCCESS = 'GET_RECOMMENDATION_WIDGETS_SUCCESS';
type GET_RECOMMENDATION_WIDGETS_SUCCESS_TYPE = 'GET_RECOMMENDATION_WIDGETS_SUCCESS';

export const GET_RECOMMENDATION_WIDGETS_FAILURE = 'GET_RECOMMENDATION_WIDGETS_FAILURE';
type GET_RECOMMENDATION_WIDGETS_FAILURE_TYPE = 'GET_RECOMMENDATION_WIDGETS_FAILURE';

type GetRecommendationWidgetsRequestAction = Action<GET_RECOMMENDATION_WIDGETS_REQUEST_TYPE, null>;

type GetRecommendationWidgetsSuccessAction = Action<
  GET_RECOMMENDATION_WIDGETS_SUCCESS_TYPE,
  { data: RecommendationWidgetsSuccess }
>;

type GetRecommendationWidgetsFailureAction = Action<
  GET_RECOMMENDATION_WIDGETS_FAILURE_TYPE,
  RecommendationFailure
>;
/* #endregion */

/* #region: Get recommendation widget */
export const GET_RECOMMENDATION_WIDGET_REQUEST = 'GET_RECOMMENDATION_WIDGET_REQUEST';
type GET_RECOMMENDATION_WIDGET_REQUEST_TYPE = 'GET_RECOMMENDATION_WIDGET_REQUEST';

export const GET_RECOMMENDATION_WIDGET_SUCCESS = 'GET_RECOMMENDATION_WIDGET_SUCCESS';
type GET_RECOMMENDATION_WIDGET_SUCCESS_TYPE = 'GET_RECOMMENDATION_WIDGET_SUCCESS';

export const GET_RECOMMENDATION_WIDGET_FAILURE = 'GET_RECOMMENDATION_WIDGET_FAILURE';
type GET_RECOMMENDATION_WIDGET_FAILURE_TYPE = 'GET_RECOMMENDATION_WIDGET_FAILURE';

type GetRecommendationWidgetRequestAction = Action<GET_RECOMMENDATION_WIDGET_REQUEST_TYPE, null>;

type GetRecommendationWidgetSuccessAction = Action<
  GET_RECOMMENDATION_WIDGET_SUCCESS_TYPE,
  {
    data: RecommendationWidgetSuccess
  }
>;

type GetRecommendationWidgetFailureAction = Action<
  GET_RECOMMENDATION_WIDGET_FAILURE_TYPE,
  RecommendationFailure
>;
/* #endregion */

/* #region: Delete recommendation widget */
export const DELETE_RECOMMENDATION_WIDGET_REQUEST = 'DELETE_RECOMMENDATION_WIDGET_REQUEST';
type DELETE_RECOMMENDATION_WIDGET_REQUEST_TYPE = 'DELETE_RECOMMENDATION_WIDGET_REQUEST';

export const DELETE_RECOMMENDATION_WIDGET_SUCCESS = 'DELETE_RECOMMENDATION_WIDGET_SUCCESS';
type DELETE_RECOMMENDATION_WIDGET_SUCCESS_TYPE = 'DELETE_RECOMMENDATION_WIDGET_SUCCESS';

export const DELETE_RECOMMENDATION_WIDGET_FAILURE = 'DELETE_RECOMMENDATION_WIDGET_FAILURE';
type DELETE_RECOMMENDATION_WIDGET_FAILURE_TYPE = 'DELETE_RECOMMENDATION_WIDGET_FAILURE';

type DeleteRecommendationWidgetRequestAction = Action<
  DELETE_RECOMMENDATION_WIDGET_REQUEST_TYPE,
  null
>;

type DeleteRecommendationWidgetSuccessAction = Action<
  DELETE_RECOMMENDATION_WIDGET_SUCCESS_TYPE,
  { data: RecommendationWidgetType }
>;

type DeleteRecommendationWidgetFailureAction = Action<
  DELETE_RECOMMENDATION_WIDGET_FAILURE_TYPE,
  RecommendationFailure
>;

/* #region: Create recommendation widget  */
export const CREATE_RECOMMENDATION_WIDGET_REQUEST = 'CREATE_RECOMMENDATION_WIDGET_REQUEST';
type CREATE_RECOMMENDATION_WIDGET_REQUEST_TYPE = 'CREATE_RECOMMENDATION_WIDGET_REQUEST';

export const CREATE_RECOMMENDATION_WIDGET_SUCCESS = 'CREATE_RECOMMENDATION_WIDGET_SUCCESS';
type CREATE_RECOMMENDATION_WIDGET_SUCCESS_TYPE = 'CREATE_RECOMMENDATION_WIDGET_SUCCESS';

export const CREATE_RECOMMENDATION_WIDGET_FAILURE = 'CREATE_RECOMMENDATION_WIDGET_FAILURE';
type CREATE_RECOMMENDATION_WIDGET_FAILURE_TYPE = 'CREATE_RECOMMENDATION_WIDGET_FAILURE';

type CreateRecommendationWidgetAction = Action<CREATE_RECOMMENDATION_WIDGET_REQUEST_TYPE, null>;

type CreateRecommendationWidgetSuccessAction = Action<
  CREATE_RECOMMENDATION_WIDGET_SUCCESS_TYPE,
  { data: CreateRecommendationWidgetSuccess }
>;

type CreateRecommendationWidgetFailureAction = Action<
  CREATE_RECOMMENDATION_WIDGET_FAILURE_TYPE,
  RecommendationFailure
>;
/* #endregion */

/* #region: Update recommendation widget*/
export const UPDATE_RECOMMENDATION_WIDGET_REQUEST = 'UPDATE_RECOMMENDATION_WIDGET_REQUEST';
type UPDATE_RECOMMENDATION_WIDGET_REQUEST_TYPE = 'UPDATE_RECOMMENDATION_WIDGET_REQUEST';

export const UPDATE_RECOMMENDATION_WIDGET_SUCCESS = 'UPDATE_RECOMMENDATION_WIDGET_SUCCESS';
type UPDATE_RECOMMENDATION_WIDGET_SUCCESS_TYPE = 'UPDATE_RECOMMENDATION_WIDGET_SUCCESS';

export const UPDATE_RECOMMENDATION_WIDGET_FAILURE = 'UPDATE_RECOMMENDATION_WIDGET_FAILURE';
type UPDATE_RECOMMENDATION_WIDGET_FAILURE_TYPE = 'UPDATE_RECOMMENDATION_WIDGET_FAILURE';

type UpdateRecommendationWidgetRequestAction = Action<
  UPDATE_RECOMMENDATION_WIDGET_REQUEST_TYPE,
  null
>;

type UpdateRecommendationWidgetSuccessAction = Action<
  UPDATE_RECOMMENDATION_WIDGET_SUCCESS_TYPE,
  { data: RecommendationWidgetType }
>;

type UpdateRecommendationWidgetFailureAction = Action<
  UPDATE_RECOMMENDATION_WIDGET_FAILURE_TYPE,
  RecommendationFailure
>;
/* #endregion */

/* #region: Update recommendation widget action */
export const UPDATE_RECOMMENDATION_WIDGET_ACTION_REQUEST =
  'UPDATE_RECOMMENDATION_WIDGET_ACTION_REQUEST';
type UPDATE_RECOMMENDATION_WIDGET_ACTION_REQUEST_TYPE =
  'UPDATE_RECOMMENDATION_WIDGET_ACTION_REQUEST';

export const UPDATE_RECOMMENDATION_WIDGET_ACTION_SUCCESS =
  'UPDATE_RECOMMENDATION_WIDGET_ACTION_SUCCESS';
type UPDATE_RECOMMENDATION_WIDGET_ACTION_SUCCESS_TYPE =
  'UPDATE_RECOMMENDATION_WIDGET_ACTION_SUCCESS';

export const UPDATE_RECOMMENDATION_WIDGET_ACTION_FAILURE =
  'UPDATE_RECOMMENDATION_WIDGET_ACTION_FAILURE';
type UPDATE_RECOMMENDATION_WIDGET_ACTION_FAILURE_TYPE =
  'UPDATE_RECOMMENDATION_WIDGET_ACTION_FAILURE';

type UpdateRecommendationWidgetActionRequestAction = Action<
  UPDATE_RECOMMENDATION_WIDGET_ACTION_REQUEST_TYPE,
  null
>;

type UpdateRecommendationWidgetActionSuccessAction = Action<
  UPDATE_RECOMMENDATION_WIDGET_ACTION_SUCCESS_TYPE,
  { data: RecommendationWidgetType }
>;

type UpdateRecommendationWidgetActionFailureAction = Action<
  UPDATE_RECOMMENDATION_WIDGET_ACTION_FAILURE_TYPE,
  RecommendationFailure
>;
/* #endregion */

/* #region: Duplicate recommendation widget*/
export const DUPLICATE_RECOMMENDATION_WIDGET_REQUEST = 'DUPLICATE_RECOMMENDATION_WIDGET_REQUEST';
type DUPLICATE_RECOMMENDATION_WIDGET_REQUEST_TYPE = 'DUPLICATE_RECOMMENDATION_WIDGET_REQUEST';

export const DUPLICATE_RECOMMENDATION_WIDGET_SUCCESS = 'DUPLICATE_RECOMMENDATION_WIDGET_SUCCESS';
type DUPLICATE_RECOMMENDATION_WIDGET_SUCCESS_TYPE = 'DUPLICATE_RECOMMENDATION_WIDGET_SUCCESS';

export const DUPLICATE_RECOMMENDATION_WIDGET_FAILURE = 'DUPLICATE_RECOMMENDATION_WIDGET_FAILURE';
type DUPLICATE_RECOMMENDATION_WIDGET_FAILURE_TYPE = 'DUPLICATE_RECOMMENDATION_WIDGET_FAILURE';

type DuplicateRecommendationWidgetRequestAction = Action<
  DUPLICATE_RECOMMENDATION_WIDGET_REQUEST_TYPE,
  null
>;

type DuplicateRecommendationWidgetSuccessAction = Action<
  DUPLICATE_RECOMMENDATION_WIDGET_SUCCESS_TYPE,
  { data: RecommendationWidgetType }
>;

type DuplicateRecommendationWidgetFailureAction = Action<
  DUPLICATE_RECOMMENDATION_WIDGET_FAILURE_TYPE,
  RecommendationFailure
>;
/* #endregion */

/* #region: Get manual recommendation  */
export const GET_MANUAL_RECOMMENDATION_REQUEST = 'GET_MANUAL_RECOMMENDATION_REQUEST';
type GET_MANUAL_RECOMMENDATION_REQUEST_TYPE = 'GET_MANUAL_RECOMMENDATION_REQUEST';

export const GET_MANUAL_RECOMMENDATION_SUCCESS = 'GET_MANUAL_RECOMMENDATION_SUCCESS';
type GET_MANUAL_RECOMMENDATION_SUCCESS_TYPE = 'GET_MANUAL_RECOMMENDATION_SUCCESS';

export const GET_MANUAL_RECOMMENDATION_FAILURE = 'GET_MANUAL_RECOMMENDATION_FAILURE';
type GET_MANUAL_RECOMMENDATION_FAILURE_TYPE = 'GET_MANUAL_RECOMMENDATION_FAILURE';

type GetManualRecommendationAction = Action<
  GET_MANUAL_RECOMMENDATION_REQUEST_TYPE,
  { type: ManualRecommendationType }
>;

type GetManualRecommendationSuccessAction = Action<
  GET_MANUAL_RECOMMENDATION_SUCCESS_TYPE,
  { data: ListManualRecommendationResponseType, type: ManualRecommendationType }
>;

type GetManualRecommendationFailureAction = Action<
  GET_MANUAL_RECOMMENDATION_FAILURE_TYPE,
  RecommendationFailure
>;
/* #endregion */

/* #region: Search manual recommendation  */
export const SEARCH_MANUAL_RECOMMENDATION_REQUEST = 'SEARCH_MANUAL_RECOMMENDATION_REQUEST';
type SEARCH_MANUAL_RECOMMENDATION_REQUEST_TYPE = 'SEARCH_MANUAL_RECOMMENDATION_REQUEST';

export const SEARCH_MANUAL_RECOMMENDATION_SUCCESS = 'SEARCH_MANUAL_RECOMMENDATION_SUCCESS';
type SEARCH_MANUAL_RECOMMENDATION_SUCCESS_TYPE = 'SEARCH_MANUAL_RECOMMENDATION_SUCCESS';

export const SEARCH_MANUAL_RECOMMENDATION_FAILURE = 'SEARCH_MANUAL_RECOMMENDATION_FAILURE';
type SEARCH_MANUAL_RECOMMENDATION_FAILURE_TYPE = 'SEARCH_MANUAL_RECOMMENDATION_FAILURE';

export const CLEAR_SEARCH_MANUAL_RECOMMENDATION = 'CLEAR_SEARCH_MANUAL_RECOMMENDATION';
type CLEAR_SEARCH_MANUAL_RECOMMENDATION_TYPE = 'CLEAR_SEARCH_MANUAL_RECOMMENDATION';

export const REMOVE_RECOMMENDATION_FROM_SEARCH_RESULT = 'REMOVE_RECOMMENDATION_FROM_SEARCH_RESULT';
type REMOVE_RECOMMENDATION_FROM_SEARCH_RESULT_TYPE = 'REMOVE_RECOMMENDATION_FROM_SEARCH_RESULT';

export const UPDATE_SEARCH_MANUAL_RECOMMENDATION_STATUS =
  'UPDATE_SEARCH_MANUAL_RECOMMENDATION_STATUS';
type UPDATE_SEARCH_MANUAL_RECOMMENDATION_STATUS_TYPE = 'UPDATE_SEARCH_MANUAL_RECOMMENDATION_STATUS';

type SearchManualRecommendationAction = Action<SEARCH_MANUAL_RECOMMENDATION_REQUEST_TYPE, null>;

type SearchManualRecommendationSuccessAction = Action<
  SEARCH_MANUAL_RECOMMENDATION_SUCCESS_TYPE,
  { data: ListManualRecommendationResponseType }
>;

type SearchManualRecommendationFailureAction = Action<
  SEARCH_MANUAL_RECOMMENDATION_FAILURE_TYPE,
  RecommendationFailure
>;

type ClearSearchManualRecommendationAction = Action<CLEAR_SEARCH_MANUAL_RECOMMENDATION_TYPE, null>;

type RemoveRecommendationFromSearchResultAction = Action<
  REMOVE_RECOMMENDATION_FROM_SEARCH_RESULT_TYPE,
  string
>;

type UpdateSearchManualRecommendationStatus = Action<
  UPDATE_SEARCH_MANUAL_RECOMMENDATION_STATUS_TYPE,
  boolean
>;

/* #endregion */

/* #region: Delete manual recommendation  */
export const DELETE_MANUAL_RECOMMENDATION_REQUEST = 'DELETE_MANUAL_RECOMMENDATION_REQUEST';
type DELETE_MANUAL_RECOMMENDATION_REQUEST_TYPE = 'DELETE_MANUAL_RECOMMENDATION_REQUEST';

export const DELETE_MANUAL_RECOMMENDATION_SUCCESS = 'DELETE_MANUAL_RECOMMENDATION_SUCCESS';
type DELETE_MANUAL_RECOMMENDATION_SUCCESS_TYPE = 'DELETE_MANUAL_RECOMMENDATION_SUCCESS';

export const DELETE_MANUAL_RECOMMENDATION_FAILURE = 'DELETE_MANUAL_RECOMMENDATION_FAILURE';
type DELETE_MANUAL_RECOMMENDATION_FAILURE_TYPE = 'DELETE_MANUAL_RECOMMENDATION_FAILURE';

type DeleteManualRecommendationAction = Action<DELETE_MANUAL_RECOMMENDATION_REQUEST_TYPE, null>;

type DeleteManualRecommendationSuccessAction = Action<
  DELETE_MANUAL_RECOMMENDATION_SUCCESS_TYPE,
  { data: any } // TODO: Update type here later
>;

type DeleteManualRecommendationFailureAction = Action<
  DELETE_MANUAL_RECOMMENDATION_FAILURE_TYPE,
  RecommendationFailure
>;
/* #endregion */

/* #region: Add manual recommendation  */
export const CREATE_MANUAL_RECOMMENDATION_REQUEST = 'CREATE_MANUAL_RECOMMENDATION_REQUEST';
type CREATE_MANUAL_RECOMMENDATION_REQUEST_TYPE = 'CREATE_MANUAL_RECOMMENDATION_REQUEST';

export const CREATE_MANUAL_RECOMMENDATION_SUCCESS = 'CREATE_MANUAL_RECOMMENDATION_SUCCESS';
type CREATE_MANUAL_RECOMMENDATION_SUCCESS_TYPE = 'CREATE_MANUAL_RECOMMENDATION_SUCCESS';

export const CREATE_MANUAL_RECOMMENDATION_FAILURE = 'CREATE_MANUAL_RECOMMENDATION_FAILURE';
type CREATE_MANUAL_RECOMMENDATION_FAILURE_TYPE = 'CREATE_MANUAL_RECOMMENDATION_FAILURE';

type CreateManualRecommendationAction = Action<CREATE_MANUAL_RECOMMENDATION_REQUEST_TYPE, null>;

type CreateManualRecommendationSuccessAction = Action<
  CREATE_MANUAL_RECOMMENDATION_SUCCESS_TYPE,
  { data: ListManualRecommendationResponseType }
>;

type CreateManualRecommendationFailureAction = Action<
  CREATE_MANUAL_RECOMMENDATION_FAILURE_TYPE,
  RecommendationFailure
>;
/* #endregion */

/* #region: Get manual recommendation by id */
export const GET_MANUAL_RECOMMENDATION_BY_ID_REQUEST = 'GET_MANUAL_RECOMMENDATION_BY_ID_REQUEST';
type GET_MANUAL_RECOMMENDATION_BY_ID_REQUEST_TYPE = 'GET_MANUAL_RECOMMENDATION_BY_ID_REQUEST';

export const GET_MANUAL_RECOMMENDATION_BY_ID_SUCCESS = 'GET_MANUAL_RECOMMENDATION_BY_ID_SUCCESS';
type GET_MANUAL_RECOMMENDATION_BY_ID_SUCCESS_TYPE = 'GET_MANUAL_RECOMMENDATION_BY_ID_SUCCESS';

export const GET_MANUAL_RECOMMENDATION_BY_ID_FAILURE = 'GET_MANUAL_RECOMMENDATION_BY_ID_FAILURE';
type GET_MANUAL_RECOMMENDATION_BY_ID_FAILURE_TYPE = 'GET_MANUAL_RECOMMENDATION_BY_ID_FAILURE';

type GetManualRecommendationByIdAction = Action<GET_MANUAL_RECOMMENDATION_BY_ID_REQUEST_TYPE, null>;

type GetManualRecommendationByIdSuccessAction = Action<
  GET_MANUAL_RECOMMENDATION_BY_ID_SUCCESS_TYPE,
  { data: ManualRecommendationResponseType }
>;

type GetManualRecommendationByIdFailureAction = Action<
  GET_MANUAL_RECOMMENDATION_BY_ID_FAILURE_TYPE,
  RecommendationFailure
>;
/* #endregion */

/* #region: Edit manual recommendation  */
export const EDIT_MANUAL_RECOMMENDATION_REQUEST = 'EDIT_MANUAL_RECOMMENDATION_REQUEST';
type EDIT_MANUAL_RECOMMENDATION_REQUEST_TYPE = 'EDIT_MANUAL_RECOMMENDATION_REQUEST';

export const EDIT_MANUAL_RECOMMENDATION_SUCCESS = 'EDIT_MANUAL_RECOMMENDATION_SUCCESS';
type EDIT_MANUAL_RECOMMENDATION_SUCCESS_TYPE = 'EDIT_MANUAL_RECOMMENDATION_SUCCESS';

export const EDIT_MANUAL_RECOMMENDATION_FAILURE = 'EDIT_MANUAL_RECOMMENDATION_FAILURE';
type EDIT_MANUAL_RECOMMENDATION_FAILURE_TYPE = 'EDIT_MANUAL_RECOMMENDATION_FAILURE';

type EditManualRecommendationAction = Action<EDIT_MANUAL_RECOMMENDATION_REQUEST_TYPE, null>;

type EditManualRecommendationSuccessAction = Action<
  EDIT_MANUAL_RECOMMENDATION_SUCCESS_TYPE,
  { data: ListManualRecommendationResponseType }
>;

type EditManualRecommendationFailureAction = Action<
  EDIT_MANUAL_RECOMMENDATION_FAILURE_TYPE,
  RecommendationFailure
>;
/* #endregion */

/* #region: Activate AI base */
export const ACTIVATE_AI_BASE_REQUEST = 'ACTIVATE_AI_BASE_REQUEST';
type ACTIVATE_AI_BASE_REQUEST_TYPE = 'ACTIVATE_AI_BASE_REQUEST';

export const ACTIVATE_AI_BASE_SUCCESS = 'ACTIVATE_AI_BASE_SUCCESS';
type ACTIVATE_AI_BASE_SUCCESS_TYPE = 'ACTIVATE_AI_BASE_SUCCESS';

export const ACTIVATE_AI_BASE_FAILURE = 'ACTIVATE_AI_BASE_FAILURE';
type ACTIVATE_AI_BASE_FAILURE_TYPE = 'ACTIVATE_AI_BASE_FAILURE';

type ActivateAIBaseAction = Action<ACTIVATE_AI_BASE_REQUEST_TYPE, null>;

type ActivateAIBaseSuccessAction = Action<
  ACTIVATE_AI_BASE_SUCCESS_TYPE,
  { data: ActivateAIBaseSuccess }
>;

type ActivateAIBaseFailureAction = Action<ACTIVATE_AI_BASE_FAILURE_TYPE, RecommendationFailure>;
/* #endregion */

/* #region: Get AI-sync status */
export const GET_AI_SYNC_STATUS_REQUEST = 'GET_AI_SYNC_STATUS_REQUEST';
type GET_AI_SYNC_STATUS_REQUEST_TYPE = 'GET_AI_SYNC_STATUS_REQUEST';

export const GET_AI_SYNC_STATUS_SUCCESS = 'GET_AI_SYNC_STATUS_SUCCESS';
type GET_AI_SYNC_STATUS_SUCCESS_TYPE = 'GET_AI_SYNC_STATUS_SUCCESS';

export const GET_AI_SYNC_STATUS_FAILURE = 'GET_AI_SYNC_STATUS_FAILURE';
type GET_AI_SYNC_STATUS_FAILURE_TYPE = 'GET_AI_SYNC_STATUS_FAILURE';

type GetAISyncStatusAction = Action<GET_AI_SYNC_STATUS_REQUEST_TYPE, null>;

type GetAISyncStatusSuccessAction = Action<
  GET_AI_SYNC_STATUS_SUCCESS_TYPE,
  { data: GetAISyncStatusSuccess }
>;

type GetAISyncStatusFailureAction = Action<GET_AI_SYNC_STATUS_FAILURE_TYPE, RecommendationFailure>;
/* #endregion */

/* #region: Get AI model statuses */
export const GET_AI_MODEL_STATUSES_REQUEST = 'GET_AI_MODEL_STATUSES_REQUEST';
type GET_AI_MODEL_STATUSES_REQUEST_TYPE = 'GET_AI_MODEL_STATUSES_REQUEST';

export const GET_AI_MODEL_STATUSES_SUCCESS = 'GET_AI_MODEL_STATUSES_SUCCESS';
type GET_AI_MODEL_STATUSES_SUCCESS_TYPE = 'GET_AI_MODEL_STATUSES_SUCCESS';

export const GET_AI_MODEL_STATUSES_FAILURE = 'GET_AI_MODEL_STATUSES_FAILURE';
type GET_AI_MODEL_STATUSES_FAILURE_TYPE = 'GET_AI_MODEL_STATUSES_FAILURE';

type GetAIModelStatusesAction = Action<GET_AI_MODEL_STATUSES_REQUEST_TYPE, null>;

type GetAIModelStatusesSuccessAction = Action<
  GET_AI_MODEL_STATUSES_SUCCESS_TYPE,
  { data: Array<AIModelStatusResponseType> }
>;

type GetAIModelStatusesFailureAction = Action<
  GET_AI_MODEL_STATUSES_FAILURE_TYPE,
  RecommendationFailure
>;
/* #endregion */

/* #region: Get AI model status */
export const GET_AI_MODEL_STATUS_REQUEST = 'GET_AI_MODEL_STATUS_REQUEST';
type GET_AI_MODEL_STATUS_REQUEST_TYPE = 'GET_AI_MODEL_STATUS_REQUEST';

export const GET_AI_MODEL_STATUS_SUCCESS = 'GET_AI_MODEL_STATUS_SUCCESS';
type GET_AI_MODEL_STATUS_SUCCESS_TYPE = 'GET_AI_MODEL_STATUS_SUCCESS';

export const GET_AI_MODEL_STATUS_FAILURE = 'GET_AI_MODEL_STATUS_FAILURE';
type GET_AI_MODEL_STATUS_FAILURE_TYPE = 'GET_AI_MODEL_STATUS_FAILURE';

type GetAIModelStatusAction = Action<GET_AI_MODEL_STATUS_REQUEST_TYPE, AIModelStatusRequestType>;

type GetAIModelStatusSuccessAction = Action<
  GET_AI_MODEL_STATUS_SUCCESS_TYPE,
  { data: AIModelStatusResponseType, type: string }
>;

type GetAIModelStatusFailureAction = Action<
  GET_AI_MODEL_STATUS_FAILURE_TYPE,
  RecommendationFailure
>;
/* #endregion */

/* #region: Get sync order status */
export const GET_SYNC_ORDER_STATUS_REQUEST = 'GET_SYNC_ORDER_STATUS_REQUEST';
type GET_SYNC_ORDER_STATUS_REQUEST_TYPE = 'GET_SYNC_ORDER_STATUS_REQUEST';

export const GET_SYNC_ORDER_STATUS_SUCCESS = 'GET_SYNC_ORDER_STATUS_SUCCESS';
type GET_SYNC_ORDER_STATUS_SUCCESS_TYPE = 'GET_SYNC_ORDER_STATUS_SUCCESS';

export const GET_SYNC_ORDER_STATUS_FAILURE = 'GET_SYNC_ORDER_STATUS_FAILURE';
type GET_SYNC_ORDER_STATUS_FAILURE_TYPE = 'GET_SYNC_ORDER_STATUS_FAILURE';

type GetSyncOrderStatusAction = Action<GET_SYNC_ORDER_STATUS_REQUEST_TYPE, null>;

type GetSyncOrderStatusSuccessAction = Action<
  GET_SYNC_ORDER_STATUS_SUCCESS_TYPE,
  { syncType: '' | '90' | '30', status: 'running' | 'done' }
>;

type GetSyncOrderStatusFailureAction = Action<
  GET_SYNC_ORDER_STATUS_FAILURE_TYPE,
  RecommendationFailure
>;
/* #endregion */

/* #region: Get sync order status */
export const CHECK_ENABLE_BOOST_CORE_REQUEST = 'CHECK_ENABLE_BOOST_CORE_REQUEST';
type CHECK_ENABLE_BOOST_CORE_REQUEST_TYPE = 'CHECK_ENABLE_BOOST_CORE_REQUEST';

export const CHECK_ENABLE_BOOST_CORE_SUCCESS = 'CHECK_ENABLE_BOOST_CORE_SUCCESS';
type CHECK_ENABLE_BOOST_CORE_SUCCESS_TYPE = 'CHECK_ENABLE_BOOST_CORE_SUCCESS';

export const CHECK_ENABLE_BOOST_CORE_FAILURE = 'CHECK_ENABLE_BOOST_CORE_FAILURE';
type CHECK_ENABLE_BOOST_CORE_FAILURE_TYPE = 'CHECK_ENABLE_BOOST_CORE_FAILURE';

type CheckEnableBoostCoreRequestAction = Action<CHECK_ENABLE_BOOST_CORE_REQUEST_TYPE, null>;

type CheckEnableBoostCoreSuccessAction = Action<
  CHECK_ENABLE_BOOST_CORE_SUCCESS_TYPE,
  { isEnableAppBoostCore: boolean, isEnableAppBlock: boolean }
>;

type CheckEnableBoostCoreFailureAction = Action<
  CHECK_ENABLE_BOOST_CORE_FAILURE_TYPE,
  RecommendationFailure
>;
/* #endregion */
/* #region: Get sync order status */
export const MARK_DONE_TOUR_WIDGET_REQUEST = 'MARK_DONE_TOUR_WIDGET_REQUEST';
type MARK_DONE_TOUR_WIDGET_REQUEST_TYPE = 'MARK_DONE_TOUR_WIDGET_REQUEST';

export const MARK_DONE_TOUR_WIDGET_SUCCESS = 'MARK_DONE_TOUR_WIDGET_SUCCESS';
type MARK_DONE_TOUR_WIDGET_SUCCESS_TYPE = 'MARK_DONE_TOUR_WIDGET_SUCCESS';

export const MARK_DONE_TOUR_WIDGET_FAILURE = 'MARK_DONE_TOUR_WIDGET_FAILURE';
type MARK_DONE_TOUR_WIDGET_FAILURE_TYPE = 'MARK_DONE_TOUR_WIDGET_FAILURE';

type MarkDoneTourWidgetRequestAction = Action<MARK_DONE_TOUR_WIDGET_REQUEST_TYPE, null>;

type MarkDoneTourWidgetSuccessAction = Action<MARK_DONE_TOUR_WIDGET_SUCCESS_TYPE, {}>;

type MarkDoneTourWidgetFailureAction = Action<
  MARK_DONE_TOUR_WIDGET_FAILURE_TYPE,
  RecommendationFailure
>;
/* #endregion */

/* #region: Get sync order status */
export const GET_DEFAULT_DESIGN_SETTINGS_REQUEST = 'GET_DEFAULT_DESIGN_SETTINGS_REQUEST';
type GET_DEFAULT_DESIGN_SETTINGS_REQUEST_TYPE = 'GET_DEFAULT_DESIGN_SETTINGS_REQUEST';

export const GET_DEFAULT_DESIGN_SETTINGS_SUCCESS = 'GET_DEFAULT_DESIGN_SETTINGS_SUCCESS';
type GET_DEFAULT_DESIGN_SETTINGS_SUCCESS_TYPE = 'GET_DEFAULT_DESIGN_SETTINGS_SUCCESS';

export const GET_DEFAULT_DESIGN_SETTINGS_FAILURE = 'GET_DEFAULT_DESIGN_SETTINGS_FAILURE';
type GET_DEFAULT_DESIGN_SETTINGS_FAILURE_TYPE = 'GET_DEFAULT_DESIGN_SETTINGS_FAILURE';

type GetDefaultDesignSettingsRequestAction = Action<GET_DEFAULT_DESIGN_SETTINGS_REQUEST_TYPE, null>;

type GetDefaultDesignSettingsSuccessAction = Action<
  GET_DEFAULT_DESIGN_SETTINGS_SUCCESS_TYPE,
  { isEnableAppBoostCore: boolean, isEnableAppBlock: boolean }
>;

type GetDefaultDesignSettingsFailureAction = Action<
  GET_DEFAULT_DESIGN_SETTINGS_FAILURE_TYPE,
  RecommendationFailure
>;
/* #endregion */

/* #region: Sync widget status */
export const SYNC_WIDGETS_REQUEST = 'SYNC_WIDGETS_REQUEST';
type SYNC_WIDGETS_REQUEST_TYPE = 'SYNC_WIDGETS_REQUEST';

export const SYNC_WIDGETS_SUCCESS = 'SYNC_WIDGETS_SUCCESS';
type SYNC_WIDGETS_SUCCESS_TYPE = 'SYNC_WIDGETS_SUCCESS';

export const SYNC_WIDGETS_FAILURE = 'SYNC_WIDGETS_FAILURE';
type SYNC_WIDGETS_FAILURE_TYPE = 'SYNC_WIDGETS_FAILURE';

type SyncWidgetsRequestAction = Action<SYNC_WIDGETS_REQUEST_TYPE, null>;

type SyncWidgetsSuccessAction = Action<
  SYNC_WIDGETS_SUCCESS_TYPE,
  { data: ListManualRecommendationResponseType }
>;

type SyncWidgetsFailureAction = Action<SYNC_WIDGETS_FAILURE_TYPE, RecommendationFailure>;
/* #region: Get recommendation general settings */
export const GET_RECOMMENDATION_GENERAL_SETTINGS_REQUEST =
  'GET_RECOMMENDATION_GENERAL_SETTINGS_REQUEST';
type GET_RECOMMENDATION_GENERAL_SETTINGS_REQUEST_TYPE =
  'GET_RECOMMENDATION_GENERAL_SETTINGS_REQUEST';

export const GET_RECOMMENDATION_GENERAL_SETTINGS_SUCCESS =
  'GET_RECOMMENDATION_GENERAL_SETTINGS_SUCCESS';
type GET_RECOMMENDATION_GENERAL_SETTINGS_SUCCESS_TYPE =
  'GET_RECOMMENDATION_GENERAL_SETTINGS_SUCCESS';

export const GET_RECOMMENDATION_GENERAL_SETTINGS_FAILURE =
  'GET_RECOMMENDATION_GENERAL_SETTINGS_FAILURE';
type GET_RECOMMENDATION_GENERAL_SETTINGS_FAILURE_TYPE =
  'GET_RECOMMENDATION_GENERAL_SETTINGS_FAILURE';

type GetRecommendationGeneralSettingsRequestAction = Action<
  GET_RECOMMENDATION_GENERAL_SETTINGS_REQUEST_TYPE,
  null
>;

type GetRecommendationGeneralSettingsSuccessAction = Action<
  GET_RECOMMENDATION_GENERAL_SETTINGS_SUCCESS_TYPE,
  any
>;

type GetRecommendationGeneralSettingsFailureAction = Action<
  GET_RECOMMENDATION_GENERAL_SETTINGS_FAILURE_TYPE,
  RecommendationFailure
>;
/* #endregion */

/* #region: Get number discount bundle */
export const GET_NUMBER_DISCOUNT_BUNDLE_REQUEST = 'GET_RECOMMENDATION_GENERAL_SETTINGS_REQUEST';
type GET_NUMBER_DISCOUNT_BUNDLE_REQUEST_TYPE = 'GET_NUMBER_DISCOUNT_BUNDLE_REQUEST';

export const GET_NUMBER_DISCOUNT_BUNDLE_SUCCESS = 'GET_NUMBER_DISCOUNT_BUNDLE_SUCCESS';
type GET_NUMBER_DISCOUNT_BUNDLE_SUCCESS_TYPE = 'GET_NUMBER_DISCOUNT_BUNDLE_SUCCESS';

export const GET_NUMBER_DISCOUNT_BUNDLE_FAILURE = 'GET_NUMBER_DISCOUNT_BUNDLE_FAILURE';
type GET_NUMBER_DISCOUNT_BUNDLE_FAILURE_TYPE = 'GET_NUMBER_DISCOUNT_BUNDLE_FAILURE';

type GetNumberDiscountBundleRequestAction = Action<GET_NUMBER_DISCOUNT_BUNDLE_REQUEST_TYPE, null>;

type GetNumberDiscountBundleSuccessAction = Action<GET_NUMBER_DISCOUNT_BUNDLE_SUCCESS_TYPE, any>;

type GetNumberDiscountBundleFailureAction = Action<
  GET_NUMBER_DISCOUNT_BUNDLE_FAILURE_TYPE,
  RecommendationFailure
>;
/* #endregion */

/* #region: Update recommendation general settings */
export const UPDATE_RECOMMENDATION_GENERAL_SETTINGS_REQUEST =
  'UPDATE_RECOMMENDATION_GENERAL_SETTINGS_REQUEST';
type UPDATE_RECOMMENDATION_GENERAL_SETTINGS_REQUEST_TYPE =
  'UPDATE_RECOMMENDATION_GENERAL_SETTINGS_REQUEST';

export const UPDATE_RECOMMENDATION_GENERAL_SETTINGS_SUCCESS =
  'UPDATE_RECOMMENDATION_GENERAL_SETTINGS_SUCCESS';
type UPDATE_RECOMMENDATION_GENERAL_SETTINGS_SUCCESS_TYPE =
  'UPDATE_RECOMMENDATION_GENERAL_SETTINGS_SUCCESS';

export const UPDATE_RECOMMENDATION_GENERAL_SETTINGS_FAILURE =
  'UPDATE_RECOMMENDATION_GENERAL_SETTINGS_FAILURE';
type UPDATE_RECOMMENDATION_GENERAL_SETTINGS_FAILURE_TYPE =
  'UPDATE_RECOMMENDATION_GENERAL_SETTINGS_FAILURE';

type UpdateRecommendationGeneralSettingsRequestAction = Action<
  UPDATE_RECOMMENDATION_GENERAL_SETTINGS_REQUEST_TYPE,
  null
>;

type UpdateRecommendationGeneralSettingsSuccessAction = Action<
  UPDATE_RECOMMENDATION_GENERAL_SETTINGS_SUCCESS_TYPE,
  any
>;

type UpdateRecommendationGeneralSettingsFailureAction = Action<
  UPDATE_RECOMMENDATION_GENERAL_SETTINGS_FAILURE_TYPE,
  RecommendationFailure
>;
/* #endregion */

// Action and State
export type RecommendationAction =
  | GetRecommendationWidgetsRequestAction
  | GetRecommendationWidgetsSuccessAction
  | GetRecommendationWidgetsFailureAction
  | GetRecommendationWidgetRequestAction
  | GetRecommendationWidgetSuccessAction
  | GetRecommendationWidgetFailureAction
  | DeleteRecommendationWidgetRequestAction
  | DeleteRecommendationWidgetSuccessAction
  | DeleteRecommendationWidgetFailureAction
  | CreateRecommendationWidgetAction
  | CreateRecommendationWidgetSuccessAction
  | CreateRecommendationWidgetFailureAction
  | UpdateRecommendationWidgetRequestAction
  | UpdateRecommendationWidgetSuccessAction
  | UpdateRecommendationWidgetFailureAction
  | UpdateRecommendationWidgetActionRequestAction
  | UpdateRecommendationWidgetActionSuccessAction
  | UpdateRecommendationWidgetActionFailureAction
  | DuplicateRecommendationWidgetRequestAction
  | DuplicateRecommendationWidgetSuccessAction
  | DuplicateRecommendationWidgetFailureAction
  | GetManualRecommendationAction
  | GetManualRecommendationSuccessAction
  | GetManualRecommendationFailureAction
  | DeleteManualRecommendationAction
  | DeleteManualRecommendationSuccessAction
  | DeleteManualRecommendationFailureAction
  | SearchManualRecommendationAction
  | SearchManualRecommendationSuccessAction
  | SearchManualRecommendationFailureAction
  | ClearSearchManualRecommendationAction
  | RemoveRecommendationFromSearchResultAction
  | CreateManualRecommendationAction
  | CreateManualRecommendationSuccessAction
  | CreateManualRecommendationFailureAction
  | GetManualRecommendationByIdAction
  | GetManualRecommendationByIdSuccessAction
  | GetManualRecommendationByIdFailureAction
  | EditManualRecommendationAction
  | EditManualRecommendationSuccessAction
  | EditManualRecommendationFailureAction
  | UpdateSearchManualRecommendationStatus
  | ActivateAIBaseAction
  | ActivateAIBaseSuccessAction
  | ActivateAIBaseFailureAction
  | GetAISyncStatusAction
  | GetAISyncStatusSuccessAction
  | GetAISyncStatusFailureAction
  | GetAIModelStatusesAction
  | GetAIModelStatusesSuccessAction
  | GetAIModelStatusesFailureAction
  | GetAIModelStatusAction
  | GetAIModelStatusSuccessAction
  | GetAIModelStatusFailureAction
  | GetSyncOrderStatusAction
  | GetSyncOrderStatusSuccessAction
  | GetSyncOrderStatusFailureAction
  | CheckEnableBoostCoreRequestAction
  | CheckEnableBoostCoreSuccessAction
  | CheckEnableBoostCoreFailureAction
  | GetNumberDiscountBundleRequestAction
  | GetNumberDiscountBundleSuccessAction
  | GetNumberDiscountBundleFailureAction
  | MarkDoneTourWidgetRequestAction
  | MarkDoneTourWidgetSuccessAction
  | MarkDoneTourWidgetFailureAction
  | GetDefaultDesignSettingsRequestAction
  | GetDefaultDesignSettingsSuccessAction
  | GetDefaultDesignSettingsFailureAction
  | SyncWidgetsRequestAction
  | SyncWidgetsSuccessAction
  | SyncWidgetsFailureAction
  | GetRecommendationGeneralSettingsRequestAction
  | GetRecommendationGeneralSettingsSuccessAction
  | GetRecommendationGeneralSettingsFailureAction
  | UpdateRecommendationGeneralSettingsRequestAction
  | UpdateRecommendationGeneralSettingsSuccessAction
  | UpdateRecommendationGeneralSettingsFailureAction;

export type RecommendationState = {
  loading: boolean,
  saving: boolean,
  deleting: boolean,
  success: boolean,
  saveSuccess: boolean,
  error: null,

  actionURL: string,

  recommendationWidget: RecommendationWidgetType,
  widgetDesignShareableSettings: WidgetDesignSettingType,
  recommendationWidgets: Array<RecommendationWidgetType>,
  total: number,
  appBlockDeepLink: string,
  embedDeepLink: string,

  widgetCreating: boolean,
  widgetCreatedSuccess: boolean,
  widgetId: string,

  widgetDuplicating: boolean,
  widgetDuplicatedSuccess: boolean,

  manualHandPickedLoading: boolean,
  manualHandPickedLoadedSuccess: boolean,
  manualHandPickedRecommendations: any[],
  manualHandPickedTotal: number,

  manualSearching: boolean,
  manualSearchSuccess: boolean,
  manualRecommendationSearchResult: any[],

  manualDeleting: boolean,
  manualDeleteSuccess: boolean,

  manualRecommendation: ManualRecommendationResponseType | null,
  manualRecommendationLoading: boolean,
  manualActionLoading: boolean,

  aimlSyncStatus: string,
  aimlModelStatus: any,

  checkingEnableBoostCore: boolean,
  isEnableAppBoostCore: boolean,

  defaultDesignSettingsLoading: boolean,
  defaultDesignSettingsLoadedSuccess: boolean,
  defaultDesignSettings: any[],

  widgetsSyncing: boolean,
  widgetSyncedSuccess: boolean
};
